import { useCallback, useEffect, useState } from 'react';
import { toast } from '@lognai/synapse-design-system-v2';

export const notifyInvoiceSuccess = (title: string, description?: string): void => {
  toast({ title, description });
};

const recent = new Map<string, number>();
/** Report once across API, query and form layers. Never log invoice payloads. */
export const notifyInvoiceError = (error: unknown): void => {
  if (!error || (error instanceof Error && error.name === 'AbortError')) return;
  const message =
    typeof error === 'string'
      ? error
      : error instanceof Error
        ? error.message
        : 'The request could not be completed. Please try again.';
  if (!message.trim()) return;
  const now = Date.now();
  for (const [key, time] of recent) if (now - time > 5000) recent.delete(key);
  if (recent.has(message)) return;
  recent.set(message, now);
  toast({
    title: 'Invoice action could not be completed',
    description: message,
    variant: 'destructive',
  });
};
export const useInvoiceErrorToast = (error: unknown): void => {
  useEffect(() => {
    if (error) notifyInvoiceError(error);
  }, [error]);
};
export const useInvoiceErrorState = (): [string, (message: string) => void] => {
  const [error, setError] = useState('');
  const update = useCallback((message: string) => {
    setError(message);
    if (message) notifyInvoiceError(message);
  }, []);
  return [error, update];
};
